(ns app.process.model
  (:require [tilakone.core :as tk]))

(defn rejecting-guards [fsm signal]
  (let [results (tk/apply-guards fsm signal)]
    (if (empty? results)
      #{:process/illegal-signal}
      (->> results
           (map (fn [[_ guard-results]]
                  (keep (fn [{::tk/keys [allow? guard]}]
                          (when-not allow?
                            (first guard)))
                        guard-results)))
           (sort-by count)
           first
           set))))

(defn rejected-by-guards
  "Returns a set of guard ids that reject given signal. If none of the guards reject
  the signal returns nil. If the signal has multiple transitions, returns the guards
  for the transition with the least amount of rejections (or nil if some transition is allowed)."
  [process signal]
  (not-empty (rejecting-guards process signal)))

(defn signal-available?
  "Returns false if `signal` is not available at all (i.e. not legal) for `process`.
  Use the function to determine if a signal exists for the current state machine configuration.
  Note: this is different from checking if a signal is permitted (which requires guards to pass)."
  [process signal]
  (-> (rejected-by-guards process signal) set (contains? :process/illegal-signal) not))
